import { useTranslation } from 'react-i18next'

import { FormModalContainer, useCloseConfirm } from '../Form'

import { QA_NAME_INVOICE_MODAL } from './InvoiceModal.constants'
import { InvoiceModalForm } from './InvoiceModalForm'

function InvoiceModal({
  documentId,
  fields,
  requestId,
  savedDocumentId,
  submitTitleKey,
  successTitleKey,
  titleKey = 'Documents.DocumentMarkAsInvoiceModal',
  withBudgetPlanNavigation,
  withFileUpload,
  onClose,
  onSubmitRequest,
  onSuccess,
}) {
  const { t } = useTranslation()

  const { handleClose, isCloseConfirm, setCloseConfirm } = useCloseConfirm({
    onClose,
  })

  return (
    <InvoiceModalForm
      FormContainer={FormModalContainer}
      containerProps={{
        isCloseConfirm,
        isFullScreen: true,
        qaName: QA_NAME_INVOICE_MODAL,
        setCloseConfirm,
        title: t(titleKey),
        onClose,
      }}
      documentId={documentId}
      fields={fields}
      requestId={requestId}
      savedDocumentId={savedDocumentId}
      submitTitleKey={submitTitleKey}
      successTitleKey={successTitleKey}
      withBudgetPlanNavigation={withBudgetPlanNavigation}
      withFileUpload={withFileUpload}
      onCancel={handleClose}
      onClose={onClose}
      onSubmitRequest={onSubmitRequest}
      onSuccess={onSuccess}
    />
  )
}

export default InvoiceModal
